'use client';

import { useEffect } from 'react';
import { useUserStore } from '@/app/(hub)/_stores/useUserStore';
import { startSessionSync } from '@/services/sessionIdentity';

export function AppInitializer() {
  useEffect(() => {
    useUserStore.getState().initialize();
    // Reload this tab when another tab logs into a different account (auth
    // cookies are browser-wide; the rendered user is per-tab). Tabs with no
    // rendered user — login page, public agent surfaces — never reload.
    return startSessionSync();
  }, []);
  return null;
}
